<template>
    <b-modal :ref="refer" :id="'modal-'+refer" centered :title="title" :content-class="'templateModal '+desing" :size="(size)?size:'md'" @hide="closeModal">
        <template v-slot:modal-header>
            <img src="/img/logo_bp.svg" alt="logo_bp.svg" style="width: 165px;margin: auto;">
            <i class="fa fa-times float-right cursor_pointer" @click="setCookieOrRedirect(false)" style="position: absolute;right: 10px;top: 10px;"></i>
        </template>
        <div class="d-block" :style="(size)?'max-width: 100%;text-align: initial;':''">
            <h3 style="font-weight: bold;">{{title}}</h3>
            <slot></slot>

        </div>
        <template v-slot:modal-footer>


            <b-button v-if="href" class="alter-btn" :href="href" :target="target"><span>Más información</span></b-button>
            <b-button v-else class="alter-btn" @click="setCookieOrRedirect(false)"><span>Aceptar</span></b-button>


        </template>
    </b-modal>
</template>

<script>
    export default {
        props: {
            'href': {},
            'title': {},
            'refer': {},
            'desing': {},
            'size': {},
            'target': {
                type: String,
                default: '_self'
            }
        },
        data() {
            return {

            }
        },
        mounted: function () {

        },
        methods: {
            closeModal(){
                // if(this.refer === "welcomeModal"){
                //     this.$emit("closeModal");
                // }

            },
            setCookieOrRedirect(redirect = false){

                this.$bvModal.hide('modal-'+this.refer);


                setCookie.then((res) => {
                    if(redirect){
                        window.location.href = this.route('register');}

                });



            }
        },
        computed: {
            register(){
                return this.route('register');
            }
        }
    }
</script>
